/*global VeloxWebView*/


var extension = {} ;
extension.name = "cleaning-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "BORDNET"       : { FR: true, DE: true, ES: true, GB: true},  
    "BORDNET_GEL_S" : { FR: true, DE: false,ES: false,GB: false},  
    "ADISAN"        : { FR: true, DE: true, ES: false,GB: false},  
    "DECALCIT_SUPER": { FR: true, DE: true, ES: true, GB: true},  
    "PROTECT_SHINE" : { FR: true, DE: true, ES: true, GB: true},
    "PROTECT_CLEAN" : { FR: true, DE: true, ES: true, GB: true} 
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_cleaning."+p)
        } ;
    }) ;
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var cleaningEl = view.viewRootEl.querySelector('[data-field-def="pool.p_cleaning"]');
        if(cleaningEl){
            view.on("render", function(){
                cleaningEl.setOptions(computeOptions()) ;
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;